/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenderAndSterilizationModel
 */
export interface GenderAndSterilizationModel {
    /**
     * 
     * @type {string}
     * @memberof GenderAndSterilizationModel
     */
    gender?: GenderAndSterilizationModelGenderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GenderAndSterilizationModel
     */
    sterilization?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GenderAndSterilizationModel
     */
    display: string;
    /**
     * 
     * @type {string}
     * @memberof GenderAndSterilizationModel
     */
    type: string;
    /**
     * Clients use the order value to sort the values in ascending order.
     * @type {number}
     * @memberof GenderAndSterilizationModel
     */
    order: number;
    /**
     * When isSelected=true, clients should reflect this value as selected. This value will be set when the request contains a petProfileId and will match the value that is set for the requested pet.
     * @type {boolean}
     * @memberof GenderAndSterilizationModel
     */
    isSelected?: boolean;
    /**
     * When isDefault=true, clients should default to this value when no other value contains isSelected=true
     * @type {boolean}
     * @memberof GenderAndSterilizationModel
     */
    isDefault?: boolean;
}


/**
 * @export
 */
export const GenderAndSterilizationModelGenderEnum = {
    Unknown: 'UNKNOWN',
    Male: 'MALE',
    Female: 'FEMALE'
} as const;
export type GenderAndSterilizationModelGenderEnum = typeof GenderAndSterilizationModelGenderEnum[keyof typeof GenderAndSterilizationModelGenderEnum];


/**
 * Check if a given object implements the GenderAndSterilizationModel interface.
 */
export function instanceOfGenderAndSterilizationModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "display" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "order" in value;

    return isInstance;
}

export function GenderAndSterilizationModelFromJSON(json: any): GenderAndSterilizationModel {
    return GenderAndSterilizationModelFromJSONTyped(json, false);
}

export function GenderAndSterilizationModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenderAndSterilizationModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'sterilization': !exists(json, 'sterilization') ? undefined : json['sterilization'],
        'display': json['display'],
        'type': json['type'],
        'order': json['order'],
        'isSelected': !exists(json, 'isSelected') ? undefined : json['isSelected'],
        'isDefault': !exists(json, 'isDefault') ? undefined : json['isDefault'],
    };
}

export function GenderAndSterilizationModelToJSON(value?: GenderAndSterilizationModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'gender': value.gender,
        'sterilization': value.sterilization,
        'display': value.display,
        'type': value.type,
        'order': value.order,
        'isSelected': value.isSelected,
        'isDefault': value.isDefault,
    };
}

